module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [(_vm.title) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c(_vm.titleHeading, {
    tag: "component"
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }, [_vm._v(" ")]), _vm._v(_vm._s(_vm.title))])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "right",
      "sm": 16,
      "md": 8,
      "lg": _vm.title ? 10 : 22
    }
  }, [_vm._v("\n      There "), _c('span', [_vm._v(_vm._s(_vm.files.length === 1 ? 'is' : 'are'))]), _vm._v(" "), _c('b', {
    key: _vm.files.length
  }, [_vm._v(_vm._s(_vm.files.length))]), _vm._v("/" + _vm._s(this.maxFiles) + "\n      "), _c('span', [_vm._v(_vm._s(_vm.files.length === 1 ? 'file' : 'files'))]), _vm._v("\n      for this " + _vm._s(this.process ? this.process : this.type) + ".\n    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "align": "right",
      "sm": 6,
      "md": 4,
      "lg": 2
    }
  }, [(_vm.files.length < _vm.maxFiles && _vm.isTowerCo()) ? _c('file-upload', {
    attrs: {
      "url": _vm.uploadUrl,
      "text": 'Upload (' + (this.maxFiles - this.files.length) + ')',
      "model": _vm.uploads,
      "list-type": "text",
      "wrap-form-item": false,
      "show-delete": false,
      "after-upload": _vm.showSuccess,
      "disabled": _vm.disabled || _vm.readOnly
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.files.length === 0) ? _c('div', [(!_vm.disabled && !_vm.readOnly) ? _c('dropzone', {
    ref: _vm.thisRef + 'Ref',
    attrs: {
      "id": _vm.thisRef,
      "use-font-awesome": true,
      "auto-process-queue": true,
      "maxFileSizeInMB": 8,
      "default-message": _vm.uploadMessage,
      "headers": _vm.options.headers,
      "options": _vm.options
    },
    on: {
      "vdropzone-success": _vm.showSuccess,
      "vdropzone-error": _vm.onError
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "xxx123"
    }
  })]) : _vm._e()], 1) : _c('div', [(!_vm.hideCarousel) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('br'), _vm._v(" "), _c('vue-flux', {
    attrs: {
      "images": _vm.images,
      "transitions": _vm.trans,
      "captions": _vm.captions
    },
    scopedSlots: _vm._u([{
      key: "caption",
      fn: function() {
        return [_c('flux-caption')]
      },
      proxy: true
    }, {
      key: "preloader",
      fn: function() {
        return [_c('flux-preloader')]
      },
      proxy: true
    }, {
      key: "pagination",
      fn: function() {
        return [_c('flux-pagination')]
      },
      proxy: true
    }, {
      key: "controls",
      fn: function() {
        return [_c('flux-controls')]
      },
      proxy: true
    }, {
      key: "index",
      fn: function() {
        return [_c('flux-index')]
      },
      proxy: true
    }], null, false, 1564339426)
  })], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.files.length > 0) ? _c('el-table', {
    attrs: {
      "data": _vm.files,
      "stripe": "",
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "File Name",
      "width": _vm.isDesktop ? 528 : 396
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          class: 'fa fa-' + (_vm.isPDF(scope.row.mimeType) ? 'file-pdf text-danger' : 'image text-primary')
        }, [_vm._v(" ")]), _c('b', [_vm._v(_vm._s(scope.row.name))]), _vm._v(" "), _c('i', {
          staticClass: "hidden-md-and-down"
        }, [_vm._v(" " + _vm._s(_vm.formatNumber(scope.row.size ? scope.row.size / 1000 : 0)) + "k.")])]
      }
    }], null, false, 1224423616)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "hidden-sm-and-down"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('center', [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "fa fa-eye"
          },
          on: {
            "click": function($event) {
              return _vm.view(scope.row)
            }
          }
        })], 1)]
      }
    }], null, false, 4272894742)
  }), _vm._v(" "), (!_vm.readOnly) ? _c('el-table-column', {
    attrs: {
      "class-name": "hidden-md-and-down"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('strong', [_c('a', {
          staticClass: "el-button",
          attrs: {
            "href": _vm.getEndpoint('/file/download/' + scope.row.url + '/' + _vm.profile().name),
            "download": scope.row.name
          }
        }, [_c('i', {
          staticClass: "fa fa-cloud-download-alt"
        })])])]
      }
    }], null, false, 1660655630)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isManager()) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "icon": "fa fa-trash-alt",
            "circle": "",
            "disabled": _vm.disabled
          },
          on: {
            "click": function($event) {
              return _vm.deleteFile(scope.row.id, scope.row.name)
            }
          }
        }) : _vm._e()]
      }
    }], null, false, 3537267103)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "hidden-md-and-down",
      "prop": "upload_at",
      "label": "Uploaded",
      "width": "285"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "fa fa-clock"
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(_vm.formatDateTime(scope.row.upload_at)))])]
      }
    }], null, false, 3076497841)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.file) ? _c('el-dialog', {
    attrs: {
      "title": _vm.file.name,
      "visible": _vm.isViewer,
      "width": "80%",
      "height": "80%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.isViewer = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [(_vm.isPDF(_vm.file.mimeType)) ? _c('pdf-viewer', {
    attrs: {
      "url": _vm.getEndpoint('/file/view/' + _vm.file.url)
    }
  }) : _c('progressive-img', {
    attrs: {
      "width": "100%",
      "height": "auto",
      "src": _vm.getEndpoint('/file/view/' + _vm.file.url)
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "plain"
    },
    on: {
      "click": function($event) {
        _vm.isViewer = false
      }
    }
  }, [_vm._v("Close")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c694f47"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/files/FilesPanel.vue
// module id = 1469
// module chunks = 0